webpackJsonp([17428148426584],{

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.KarriereQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _slugify = __webpack_require__(17);
	
	var _reactBackgroundImageLoader = __webpack_require__(36);
	
	var _reactBackgroundImageLoader2 = _interopRequireDefault(_reactBackgroundImageLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseHref = 'http://46.4.51.11:1337';
	
	var DetKarriere = function DetKarriere(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'jobsDetail bg-white' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        data.strapiStellenangebote.Title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'tags' },
	        data.strapiStellenangebote.Job_Location
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        _reactBackgroundImageLoader2.default,
	        { className: 'Job_BG', src: data.strapiMetadata.jobs_placeholder.publicURL, placeholder: BaseHref + data.strapiMetadata.placeholder_img.url },
	        ' '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-2 desktop-only' },
	        _react2.default.createElement(
	          'a',
	          { href: data.strapiStellenangebote.Job_Download.publicURL, download: "Stellenausschreibung-" + (0, _slugify.slugify)(data.strapiStellenangebote.Title) + '-' + (0, _slugify.slugify)(data.strapiStellenangebote.Job_Location) + '.pdf', target: '_blank', type: 'application/octet-stream' },
	          _react2.default.createElement(
	            'button',
	            null,
	            'Download PDF'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-10 col-xs-12 right' },
	        _react2.default.createElement(
	          'p',
	          { className: 'intro' },
	          'Wir sind ein erfolgreiches und expandierendes Ingenieurunternehmen mit derzeit 25 Mitarbeitern im Bereich Geotechnik/Tunnelbau/Wasserbau mit Stammsitz in M\xFCnchen. Eine unserer Kernkompetenzen haben wir im Ingenieur- und Verkehrswegebau, in dem wir als Planer, Pr\xFCfer, Gutachter und Bau\xFCberwacher t\xE4tig sind. Unsere Kompetenz ist aktuell z. B. in verschiedenen Abschnitten des Gro\xDFprojekts Stuttgarts 21 sowie beim Gro\xDFprojekt 2. S-Bahn-Stammstrecke M\xFCnchen gefragt. Seit vielen Jahren sind wir auch \xFCberregional und im Ausland mit unseren Teams vertreten.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Zur Verst\xE4rkung unseres Teams am Arbeitsort ',
	            data.strapiStellenangebote.Job_Location,
	            ' suchen wir eine/n ',
	            data.strapiStellenangebote.Title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-xs-12' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Ihre Aufgaben:'
	              )
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.strapiStellenangebote.Job_Tasks } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 col-xs-12' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Ihr Profil:'
	              )
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.strapiStellenangebote.Job_Profile } })
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Wir bieten Ihnen:'
	          )
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.strapiStellenangebote.Job_More } }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Interessiert?'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Dann freuen wir uns auf Ihre aussagekr\xE4ftigen Unterlagen einschlie\xDFlich Angabe Ihrer Gehaltsvorstellung und Ihres fr\xFChestm\xF6glichen Eintrittstermins an:'
	        ),
	        _react2.default.createElement(
	          'center',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: "mailto:" + data.strapiStellenangebote.Job_Contact_Email + "?subject=Bewerbung " + data.strapiStellenangebote.Title + " / Standort " + data.strapiStellenangebote.Job_Location },
	            _react2.default.createElement(
	              'button',
	              null,
	              data.strapiStellenangebote.Job_Contact_Email
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          data.strapiStellenangebote.Job_Contact
	        )
	      )
	    )
	  );
	};
	
	exports.default = DetKarriere;
	var KarriereQuery = exports.KarriereQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-karriere-detail-js-82aab7064921b1d80f6e.js